<template>
	<app-page>
		<app-heading title="MarketMath Sponsors">
			<template v-slot:left>
				<app-button v-if="$ravello.can('marketmath.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'marketsponsor', params: { sponsor: 'new' } }"
				>Add Sponsor</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="sponsors"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchSponsors"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('marketmath.put')"
							color="secondary"
							:to="{ name: 'marketsponsor', params: { sponsor: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('marketmath.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove sponsor <b>${item.name}</b>?`"
							title="Remove Sponsor"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'marketsponsor', params: { sponsor: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			sponsors: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Agent Name',
				value: 'agent',
				sortable: true,
			}, {
				text: 'Email',
				value: 'email',
				sortable: true,
			}, {
				text: 'Phone',
				value: 'phone',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchSponsors(pagination) {
			const request = this.$ravello.graphql('marketsponsors')
				.fromPagination(pagination)
				.fields(['_id', 'name', 'agent', 'email', 'phone'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.sponsors = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('marketsponsors')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
